import { createRouter, createWebHistory } from 'vue-router';


const HomePage = () => import('../views/HomePage.vue')
const LoginSignin = () => import('../views/LoginSignin.vue')

const BackStage = () => import('../views/BackStage.vue')

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/login',
    name: 'LoginSignin',
    component: LoginSignin
  },
  {
    path: '/backstage',
    name: 'BackStage',
    component: BackStage
  },


]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // 使用 HTML5 history 模式（无 # 号）
  routes // 注入路由规则
})

export default router